import keyMirror from 'react-utils/keyMirror';
import { createAction, createRequestTypes, createRequestActions } from './utils';
export const ProfileActionTypes = keyMirror({
  LOAD_PROFILE: null,
  LOAD_IS_SCIM_USER: null,
  UPDATE_PROFILE: null,
  UPDATE_BLANK_PROFILE: null,
  UPDATE_PASSWORD: null,
  RESET_PASSWORD: null,
  DELETE_SELF: null
});
export const FETCH_PROFILE = 'FETCH_PROFILE';
export const FETCH_IS_SCIM_USER = 'FETCH_IS_SCIM_USER';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_BLANK_PROFILE = 'UPDATE_BLANK_PROFILE';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const DELETE_SELF = 'DELETE_SELF';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_ALL_SESSIONS = 'LOGOUT_ALL_SESSIONS';
export const FetchProfileActionTypes = createRequestTypes(FETCH_PROFILE);
export const FetchIsScimUserActionTypes = createRequestTypes(FETCH_IS_SCIM_USER);
export const UpdateProfileActionTypes = createRequestTypes(UPDATE_PROFILE);
export const UpdateBlankProfileActionTypes = createRequestTypes(UPDATE_BLANK_PROFILE);
export const UpdatePasswordActionTypes = createRequestTypes(UPDATE_PASSWORD);
export const ResetPasswordActionTypes = createRequestTypes(RESET_PASSWORD);
export const DeleteSelfActionTypes = createRequestTypes(DELETE_SELF);
export const FetchProfile = createRequestActions(FetchProfileActionTypes);
export const FetchIsScimUser = createRequestActions(FetchIsScimUserActionTypes);
export const UpdateProfile = createRequestActions(UpdateProfileActionTypes);
export const UpdateBlankProfile = createRequestActions(UpdateBlankProfileActionTypes);
export const UpdatePassword = createRequestActions(UpdatePasswordActionTypes);
export const ResetPassword = createRequestActions(ResetPasswordActionTypes);
export const DeleteSelf = createRequestActions(DeleteSelfActionTypes);
export const loadProfile = () => createAction(ProfileActionTypes.LOAD_PROFILE, {
  data: {
    hubless: false
  }
});
export const loadProfileHubless = () => createAction(ProfileActionTypes.LOAD_PROFILE, {
  data: {
    hubless: true
  }
});
export const loadIsScimUser = () => createAction(ProfileActionTypes.LOAD_IS_SCIM_USER);
export const updateProfile = profile => createAction(ProfileActionTypes.UPDATE_PROFILE, {
  data: profile
});
export const updateBlankProfile = profile => createAction(ProfileActionTypes.UPDATE_BLANK_PROFILE, {
  data: profile
});
export const updatePassword = (currentPassword, newPassword) => createAction(ProfileActionTypes.UPDATE_PASSWORD, {
  data: {
    currentPassword,
    newPassword
  }
});
export const resetPassword = email => createAction(ProfileActionTypes.RESET_PASSWORD, {
  data: email
});
export const deleteSelf = () => createAction(ProfileActionTypes.DELETE_SELF, {});
export const logout = () => createAction(LOGOUT, {});
export const logoutAllSessions = () => createAction(LOGOUT_ALL_SESSIONS, {});